var map = {
	"./add-thin.svg": "c399",
	"./add.svg": "ce0a",
	"./article.svg": "ddc3",
	"./delete.svg": "4612",
	"./edit.svg": "cfae",
	"./game.svg": "9fa9",
	"./home.svg": "2929",
	"./no-picture.svg": "3fc2",
	"./order.svg": "08e7",
	"./overview.svg": "2d3e",
	"./settings.svg": "e234",
	"./user.svg": "5b61",
	"./view.svg": "abcf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a673f";